import { LocationOverview } from "./LocationOverview";

export default LocationOverview;
